import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { DealsFaq } from '../components/Faq/deals-faq'

export const mount: MountWithRootOptions = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<DealsFaq {...renderProps} />, rootElement, rootOptions)
}
